window.hcRelatedSwatches = (() => {
  const getSearchTagFromTags = (tags, prefix) => {
    return tags.find(tag => tag.match(new RegExp(`^${prefix}`, 'i')));
  }
  const generateSearchUrl = (tag, template) => `/search?q=tag:${tag}&type=product&view=${template}`;
  const getSwatches = url => shop.sections.getById('hc-related-swatches', url);
  const getLoadInElement = selectorOrDom => ((typeof selectorOrDom == 'string') && document.querySelector(selectorOrDom)) || (selectorOrDom instanceof HTMLElement && selectorOrDom);
  const registerSwatches = async (productTags, loadInElement, tagPrefix = 'related_', template = 'hc-related-swatches', templateSelector = '[hc-related-swatches]') => {
    const tag = getSearchTagFromTags(productTags, tagPrefix);
    if (!tag) return null;
    const swatchesBody = await getSwatches(generateSearchUrl(tag, template));
    const swatches = swatchesBody.querySelector(templateSelector);
    const cont = getLoadInElement(loadInElement);
    if (swatches) cont.append(swatches);
    return swatches;
  }
  return registerSwatches;
})();